function setTrackingSearchResultType(searchResultType) {
    if (!this.trackingEnabled()) {
        return;
    }
    xt.srt = searchResultType;
}

function captureTrackingEvent(user, category, action, label, value = null, attr = null) {
    if (!this.trackingEnabled()) {
        return;
    }
    // xpa = function(user, category, action, label, value, attr)
    xpa(user, category, action, label, value, attr);
}

function trackingEnabled() {
    if (typeof xpa === 'undefined') {
        return false;
    }

    if (typeof xt === 'undefined') {
        return false;
    }

    return true;
}

export default {
    methods: {
        setTrackingSearchResultType,
        captureTrackingEvent,
        trackingEnabled,
    }
}